import { FC, ReactNode } from 'react';
import { Page } from './ExamImportPage.styles';
import { Stack } from '@gemini/fe-ds-core';
import ExamImportHeader from '@pages/ExamImportPage/ExamImportHeader/ExamImportHeader';
import AppointmentFilter from '@pages/ExamImportPage/AppointmentFilter/AppointmentFilter';
import AppointmentsContextProvider from '@context/AppointmentsContextProvider';
import AppointmentGrid from '@pages/ExamImportPage/AppointmentGrid/AppointmentGrid';
import ExamDataModal from '@pages/ExamImportPage/ExamDataModal/ExamDataModal';
import ImportDeviceDataContextProvider from '@context/ImportDeviceDataContextProvider';
import OrganizationLocationContextProvider from '@context/OrganizationLocationContextProvider';

interface ExamImportPageProps {
  children?: ReactNode;
}

const ExamImportPage: FC<ExamImportPageProps> = () => {

  return (
    <OrganizationLocationContextProvider>
      <AppointmentsContextProvider>
        <ImportDeviceDataContextProvider>
          <ExamDataModal />
          <Page>
            <Stack flexDirection={'column'} gap={'1.5rem'} width={'100%'}>
              <ExamImportHeader />
              <AppointmentFilter />
              <AppointmentGrid />
            </Stack>
          </Page>
        </ImportDeviceDataContextProvider>
      </AppointmentsContextProvider>
    </OrganizationLocationContextProvider>
  );
};

export default ExamImportPage;
